import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'chameleon/ui-stack/ui/buttons/dropdown-button';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import A11y from 'chameleon/ui-stack/utilities/a11y';

const DropdownWithButton = (props) => {
  const {
    button,
    containerClassName,
    icon,
    iconClassName,
    iconWidth,
    iconHeight,
    options,
    ...otherProps
  } = props;
  const iconProps = { icon, iconClassName, iconWidth, iconHeight };

  return (
    <PopOver
      position="bottom"
      isNarrow
      hideArrow
      trigger={
        <DropdownButton
          containerClassName={containerClassName}
          {...iconProps}
          {...otherProps}
        >
          {button}
        </DropdownButton>
      }
    >
      <div className="flex flex-column">
        {options.map(({ title, action }, index) => (
          <A11y key={`dropdown-options-${index}`}>
            <div
              className="cursor-pointer whitespace-nowrap hover:bg-gray-200 px-4.2 py-4.2"
              role="button"
              onClick={action}
              aria-label={title}
              tabIndex={0}
            >
              {title}
            </div>
          </A11y>
        ))}
      </div>
    </PopOver>
  );
};

DropdownWithButton.propTypes = {
  button: PropTypes.node.isRequired,
  containerClassName: PropTypes.string,
  icon: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  iconWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onToggle: PropTypes.func,
  options: PropTypes.array.isRequired,
};

DropdownWithButton.defaultProps = {
  iconClassName: '',
  containerClassName: '',
  iconWidth: null,
  iconHeight: null,
  onToggle: null,
};

export default DropdownWithButton;
